<template functional>
  <a href="#" @click="$options.OpenSelect(props)">{{
    props.row[props.column]
  }}</a>
</template>

<script>
export default {
  name: "HyperlinkDashboard",
  OpenSelect(props) {
    props.OpenSelect(props);
  }
};
</script>
